import React from 'react';

import Table from 'components/clarity-ui/components/table/table';
import TableHeader from 'components/clarity-ui/components/table/tableHeader';
import TableRow from 'components/clarity-ui/components/table/tableRow';
import TableData from 'components/clarity-ui/components/table/tableData';
import { formatDate } from 'helpers/formatters';

class ClassifierOverviewTableComponent extends React.Component {

  getCoverage (classifier) {
    if (classifier && classifier.coverage) {
      return parseFloat((classifier.coverage) * 100).toFixed(2) + '%';
    } else {
      return '';
    }
  }

  render () {
    const { classifier } = this.props;
    return (
      <Table>
        <tbody>
          <TableRow isHeader>
            <TableHeader>OVERVIEW</TableHeader>
            <TableHeader>&nbsp;</TableHeader>
          </TableRow>
          <TableRow>
            <TableData>Id:</TableData>
            <TableData>{ classifier ? classifier.id : '' }</TableData>
          </TableRow>
          <TableRow>
            <TableData>Name:</TableData>
            <TableData>{ classifier ? classifier.name : '' }</TableData>
          </TableRow>
          <TableRow>
            <TableData>Type:</TableData>
            <TableData>{ classifier ? classifier.type : '' }</TableData>
          </TableRow>
          <TableRow>
            <TableData>Enabled Since:</TableData>
            <TableData>{ classifier ? formatDate(classifier.enabledSince) : '' }</TableData>
          </TableRow>
          <TableRow>
            <TableData>Coverage:</TableData>
            <TableData>{ this.getCoverage(classifier) }</TableData>
          </TableRow>
        </tbody>
      </Table>
    );
  }
}

export default ClassifierOverviewTableComponent;



// WEBPACK FOOTER //
// ./src/components/classifier/classifierOverviewTable.component.jsx